import React, { useMemo , useState, useEffect} from 'react';
import { useFakeData } from '@/api/fakeData/useFakeData';
import QFHeader from './components/QFHeader/QFHeader';
import ClinicalSubmission from './components/ClinicalSubmission/ClinicalSubmission';
import OpsValuation from './components/OpsValuation/OpsValuation';
import './style.css';
import QuotationFinalizeSkeleton from './components/skeleton/QuotationFinalizeSkeleton';
import { useParams } from 'react-router-dom';
import { useGet } from '@/api/hooks';
import OperationalAddons from '../QuotationProcess/components/OperationalAddons/OperationalAddons';
import { GetAMOrderProviderQuotationResponseDetails } from "@/api/endpoints";

const ACMQuotationDetailsPage = () => {
  const {id, medicalOrderId, hospitalRequestId} = useParams();

  
      const { result: quotationData, isPending } = useGet({
          endPoint: GetAMOrderProviderQuotationResponseDetails,
          depArr: [hospitalRequestId],
          allowFetch: !!hospitalRequestId,
          params: [hospitalRequestId]
      });
   

  if(isPending) return <QuotationFinalizeSkeleton />

  return (
    <div className="d-flex flex-column gap-3 mx-md-5 mx-2 qf-page">
      <QFHeader data={quotationData} />
      <div className="qf-layout">
        <div className="d-flex flex-column gap-3">
          <ClinicalSubmission data={quotationData} />
          <OperationalAddons
              addons={quotationData?.addOns}
            />
        </div>
        <OpsValuation data={quotationData} />
      </div>
    </div>
  );
};

export default ACMQuotationDetailsPage;
